import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';
import { UpsertMaterialPriceArgs, shadowUpsertMaterialPrice } from './shadow-upsert-material-price';

export const saveMaterialPrice = ({ materialId, price }: UpsertMaterialPriceArgs) => {
    shadowUpsertMaterialPrice({ materialId, price });

    return axios.post(API_URLS.OWN_MATERIALS.SET_PRICE, { materialId, price });
};
